<ng-container *ngIf="approval">
  <div [ngSwitch]="approval.calculationType | lowercase">
    <app-loc-term-approval *ngSwitchCase="'loc'" [initializeExpanded]="approvalsCount === 1" [approval]="approval">
    </app-loc-term-approval>
    <app-loc-term-approval *ngSwitchCase="'term'" [initializeExpanded]="approvals && approvals.length === 1"
      [approval]="approval">
    </app-loc-term-approval>
    <app-approval *ngSwitchDefault 
      [readOnly]="readOnly" 
      [initializeExpanded]="approvalsCount === 1"
      [disabled]="approval.calculationType === 'custom' && customControlsDisabled"
      [channel]="getCalcChannel(approval.id)" 
      [approval]="approval" 
      [editModalOverrideData]="editModalOverrideData"
      [hideHeader]="hideHeader" 
      [hideCreateOptionButton]="hideCreateOptionButton" 
      [loading]="getLoading(approval?.id)" 
      [errored]="getErrored(approval?.id)"
      (error)="setErrored($event)" 
      (approvalAdjusted)="handleAdjustedApproval($event)"
      (pusherPayloadReceived)="handlePusherPayloadReceived($event)"
      (calculationUpdate)="handleCalculationUpdate($event)">
    </app-approval>
  </div>
</ng-container>
